import SettingsEdit from "../../../../../components/Forms/settings/Edit";
import SettingsView from "../../../../../components/Forms/settings/View";

const mod = 'tazama';

export function TAZAMASettingsView() {
  return <SettingsView mod={mod} />;
}

export function TAZAMASettingsEdit() {
  return <SettingsEdit mod={mod} />;
}
